/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { ScreenName } from '../lib/enums';
import { CartProvider } from '../hooks/cart/CartProvider';
import { useDeviceEvent } from '../hooks/device/useDeviceEvent';
import { useCartSwitcherEffect } from '../hooks/useCartNavigationHelper/useCartSwitcherEffect';
import CartScreen from '../screens/CartScreen/CartScreen';
import IdleScreen from '../screens/IdleScreen/IdleScreen';
import PaymentScreen from '../screens/PaymentScreen/PaymentScreen';
import SendReceiptScreen from '../screens/SendReceiptScreen/SendReceiptScreen';
import { Platform } from 'react-native';
import { useStore } from '../hooks/store/useStore';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

export interface CartSwitcherProps {
  children: React.ReactNode;
}
const Stack = createNativeStackNavigator();

export const CartSwitcherController: React.FC<CartSwitcherProps> = ({
  children,
}) => {
  useCartSwitcherEffect();
  useDeviceEvent();
  useStore();
  return <>{children}</>;
};

export const CartNavigator: React.FC = () => {
  return (
    <CartProvider>
      <CartSwitcherController>
        <Stack.Navigator
          screenOptions={{
            headerShown: false, // Keep the header hidden
            presentation:
              Platform.OS === 'android' ? 'transparentModal' : 'card',
          }}
        >
          <Stack.Screen
            component={IdleScreen}
            name={ScreenName.IDLE}
            options={{ title: ScreenName.IDLE }}
          />
          <Stack.Screen
            component={CartScreen}
            name={ScreenName.CART}
            options={{ title: ScreenName.CART }}
          />
          <Stack.Screen
            component={PaymentScreen}
            name={ScreenName.PAYMENT}
            options={{ title: ScreenName.PAYMENT }}
          />
          <Stack.Screen
            component={SendReceiptScreen}
            name={ScreenName.SEND_RECEIPT}
            options={{ title: ScreenName.SEND_RECEIPT }}
          />
        </Stack.Navigator>
      </CartSwitcherController>
    </CartProvider>
  );
};
